// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TotalsSection_wrapper__N36xa"};